import { inject, Injectable } from '@angular/core';
import { CurrentUser, CurrentUserService } from '@rma/generic/ng/user';
import { Observable } from 'rxjs';

/**
 * PublicUserContextService
 *
 * Public's per-app user service - the analog of DashboardUserContextService. It exposes the signed-in user (identity)
 * by delegating to the base CurrentUserService, so public consumers depend on this rather than the base directly.
 * Profile concerns (profileCode, Agent vs Agency, vertical, ...) live on PublicProfileContextService, not here.
 */
@Injectable({
  providedIn: 'root',
})
export class PublicUserContextService {
  private readonly currentUserService = inject(CurrentUserService);

  public get currentUser$(): Observable<CurrentUser | null> {
    return this.currentUserService.currentUser$;
  }

  public get isAuthenticated$(): Observable<boolean> {
    return this.currentUserService.isAuthenticated$;
  }

  public reloadUser(): Observable<CurrentUser | null> {
    return this.currentUserService.reloadUser();
  }

  public onLogout(): void {
    this.currentUserService.onLogout();
  }
}
